<div class="staff-import-wrapper">
    <div id="staff-import" class="staff-import">
        <div class="card-box">
            <h2>Importar Bajas</h2>
            <div class="button-row">
                <button mat-raised-button color="accent" (click)="openImportarEmpresa()">Especificar empresas</button>
                <button mat-raised-button color="accent" (click)="openCriteriasDialog()">Criterios</button>
                <button mat-raised-button color="accent" (click)="onUploadFile()">Importar</button><!-- En producción está deshabilitado este botón 07/06/2023, en UAT habilitado para pruebas-->
            </div>
        </div>
    </div>

    <div class="staff-import-content">
        <div class="left">
            <app-leave-import-parameter [parameters-form]="parametersForm" [templates-list]="templatesList"
                [tipos-de-baha-fromsarray]="tiposDeBajaFormArray" [(selectedFile)]="selectedFileInBase64"
                (template-save-click)="onTemplateSaveClick()" (template-delete-click)="onDeleteTemplateClick()">
            </app-leave-import-parameter>
        </div>
 
        <div class="right">
            <!-- <app-leave-import-excel [(excelColumnData)]="excelColumnsData"></app-leave-import-excel> -->
            <app-leave-import-excel></app-leave-import-excel>
        </div>
    </div>
</div>